import HttpService from './http';

export default class VendorHttpService {
  static get = async vendor_uid => {
    const url = `/v2.0/vendors/${vendor_uid}`;
    return await HttpService.get(url, false);
  };

  static getOfEvent = async (vendor_uid, marketplace_uid) => {
    const url = `/v2.0/vendors/${vendor_uid}/event/${marketplace_uid}`;
    return await HttpService.get(url, false);
  };

  static listOfEvent = async marketplace_uid => {
    const url = `/v2.0/vendors/event/${marketplace_uid}`;
    return await HttpService.get(url, false);
  };
}
